import { getLiabilitiesByLevels, getLiabilitiesSummaryCards } from "@/api/financialReport";
import { createBalanceLevelReport } from "./createBalanceLevelReport";

// Tab Pasivos: saldo acumulado del nivel-1 "Pasivos". Misma lógica que Activos
// (factory compartido), sólo cambia el endpoint y las etiquetas.
export default createBalanceLevelReport({
    fetchBreakdown: getLiabilitiesByLevels,
    fetchSummary: getLiabilitiesSummaryCards,
    totalLabel: "Pasivos",
    ratioLabel: "Pasivos / Ventas (%)",
    errorLabel: "Error al cargar pasivos.",
    summaryErrorLabel: "Error al cargar resumen de pasivos.",
    logPrefix: "[liabilitiesReport]",
});
